export { default } from "../../admin/cases/[caseId]/statement";
